import axios from '../utils/axios';

export default function fetchPremiumRecruitersCount(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/premium-registered-recruiters-count', { params })
            .then(res => {
                return res.data
            })
            .catch(err => {
                return err;
            })
    )
}
